import React from 'react';

const CategoryFilter = ({ selectedCategory, onCategoryChange }) => {
    // Using the actual category constants from backend with emojis
    const categories = [
        { id: 'Tech & Gadgets', emoji: '📱', label: 'Tech & Gadgets' },
        { id: 'Luxury & Designer', emoji: '💎', label: 'Luxury & Designer' },
        { id: 'Home & Living', emoji: '🏠', label: 'Home & Living' },
        { id: 'Fashion & Accessories', emoji: '👗', label: 'Fashion & Accessories' },
        { id: 'Wellness & Lifestyle', emoji: '🧘', label: 'Wellness & Lifestyle' },
        { id: 'Travel & Adventure', emoji: '✈️', label: 'Travel & Adventure' },
        { id: 'Entertainment', emoji: '🎬', label: 'Entertainment' },
        { id: 'Gourmet & Food', emoji: '🍷', label: 'Gourmet & Food' },
        { id: 'Experiences', emoji: '🎪', label: 'Experiences' },
        { id: 'For the Home Office', emoji: '💼', label: 'For the Home Office' }
    ];

    return (
        <div>
            <h3 className="font-medium text-accent-800 mb-3 flex items-center">
                🏷️ Category
            </h3>

            <div className="grid grid-cols-2 gap-2">
                {categories.map((category) => (
                    <button
                        key={category.id}
                        onClick={() => onCategoryChange(category.id)}
                        className={`p-2 rounded-lg text-center transition-all duration-200 ${selectedCategory === category.id
                            ? 'border-2 border-indigo-600 bg-indigo-200 shadow-inner transform scale-95'
                            : 'border-2 border-accent-200 hover:border-accent-300 bg-white hover:bg-accent-50 shadow-sm'
                            }`}
                    >
                        <div className="text-lg mb-1">{category.emoji}</div>
                        <div className={`text-xs ${selectedCategory === category.id
                            ? 'font-bold text-indigo-800'
                            : 'font-medium text-accent-600'
                            }`}>
                            {category.label}
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CategoryFilter; 